@let obs =
  {
    currentProfile: currentProfile$ | async,
  };

@if (obs.currentProfile) {
  <h1>Спасибо, {{ obs.currentProfile.user?.firstName || 'Строитель' }}!</h1>
}
